<template>
  <ModalFormulario
    :model-value="modelValue"
    titulo="Alterar Senha"
    tamanho="sm"
    :loading="isLoading"
    @update:model-value="$emit('update:modelValue', $event)"
    @confirmar="handleAlterarSenha"
  >
    <div v-if="mensagemSucesso" class="alert alert-success border-0 shadow-sm text-center">
      <i class="bi bi-check-circle-fill fs-4 d-block mb-2 text-success"></i>
      <p class="mb-0">{{ mensagemSucesso }}</p>
    </div>

    <template v-else>
      <div v-if="erro" class="alert alert-danger border-0 shadow-sm">
        <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ erro }}
      </div>

      <div class="mb-3">
        <label for="senhaAtual" class="form-label">Senha Atual</label>
        <div class="input-group">
          <input
            :type="showSenhaAtual ? 'text' : 'password'"
            class="form-control"
            id="senhaAtual"
            name="current-password"
            autocomplete="current-password"
            v-model="senhaAtual"
            required
            placeholder="••••••••"
            :disabled="isLoading"
          />
          <button class="btn btn-outline-secondary" type="button" @click="showSenhaAtual = !showSenhaAtual" tabindex="-1" :disabled="isLoading" :title="showSenhaAtual ? 'Ocultar senha' : 'Mostrar senha'">
            <i :class="['bi', showSenhaAtual ? 'bi-eye-slash' : 'bi-eye']"></i>
          </button>
        </div>
      </div>

      <div class="mb-3">
        <label for="novaSenha" class="form-label">Nova Senha</label>
        <div class="input-group">
          <input
            :type="showNovaSenha ? 'text' : 'password'"
            class="form-control"
            id="novaSenha"
            name="new-password"
            autocomplete="new-password"
            v-model="novaSenha"
            required
            minlength="6"
            placeholder="••••••••"
            :disabled="isLoading"
          />
          <button class="btn btn-outline-secondary" type="button" @click="showNovaSenha = !showNovaSenha" tabindex="-1" :disabled="isLoading" :title="showNovaSenha ? 'Ocultar senha' : 'Mostrar senha'">
            <i :class="['bi', showNovaSenha ? 'bi-eye-slash' : 'bi-eye']"></i>
          </button>
        </div>
      </div>

      <div class="mb-3">
        <label for="confirmarSenha" class="form-label">Confirmar Nova Senha</label>
        <div class="input-group">
          <input
            :type="showConfirmarSenha ? 'text' : 'password'"
            class="form-control"
            id="confirmarSenha"
            name="new-password"
            autocomplete="new-password"
            v-model="confirmarSenha"
            required
            minlength="6"
            placeholder="••••••••"
            :disabled="isLoading"
          />
          <button class="btn btn-outline-secondary" type="button" @click="showConfirmarSenha = !showConfirmarSenha" tabindex="-1" :disabled="isLoading" :title="showConfirmarSenha ? 'Ocultar senha' : 'Mostrar senha'">
            <i :class="['bi', showConfirmarSenha ? 'bi-eye-slash' : 'bi-eye']"></i>
          </button>
        </div>
      </div>
    </template>
  </ModalFormulario>
</template>

<script setup>
import { ref, watch } from 'vue'
import api from '@/services/api'
import ModalFormulario from '../base/modal/ModalFormulario.vue'

const props = defineProps({
  modelValue: Boolean
})

const emit = defineEmits(['update:modelValue', 'senha-alterada'])

const senhaAtual = ref('')
const novaSenha = ref('')
const confirmarSenha = ref('')
const showSenhaAtual = ref(false)
const showNovaSenha = ref(false)
const showConfirmarSenha = ref(false)
const erro = ref(null)
const isLoading = ref(false)
const mensagemSucesso = ref(null)

watch(() => props.modelValue, (novoValor) => {
  if (novoValor) {
    senhaAtual.value = ''
    novaSenha.value = ''
    confirmarSenha.value = ''
    showSenhaAtual.value = false
    showNovaSenha.value = false
    showConfirmarSenha.value = false
    erro.value = null
    mensagemSucesso.value = null
  }
})

const handleAlterarSenha = async () => {
  isLoading.value = true
  erro.value = null

  if (novaSenha.value !== confirmarSenha.value) {
    erro.value = 'As senhas não coincidem.'
    isLoading.value = false
    return
  }

  if (novaSenha.value.length < 6) {
    erro.value = 'A nova senha deve ter no mínimo 6 caracteres.'
    isLoading.value = false
    return
  }

  try {
    await api.post('/Auth/alterar-senha', {
      senhaAtual: senhaAtual.value,
      novaSenha: novaSenha.value,
      confirmarSenha: confirmarSenha.value
    })
    mensagemSucesso.value = 'Senha alterada com sucesso!'
    emit('senha-alterada')
    setTimeout(() => {
      emit('update:modelValue', false)
    }, 1500)
  } catch (error) {
    if (error.response && error.response.status === 400) {
      const validationErrors = error.response.data.errors
      if (validationErrors) {
        const firstErrorField = Object.keys(validationErrors)[0]
        erro.value = validationErrors[firstErrorField][0]
      } else {
        erro.value = error.response.data.message || 'Dados inválidos. Verifique o formulário.'
      }
    } else {
      erro.value = 'Não foi possível conectar ao servidor. Tente novamente mais tarde.'
    }
    console.error('Erro ao alterar senha:', error)
  } finally {
    isLoading.value = false
  }
}
</script>
